const ChipMap = {
    Layout: {
        id: '260709',
        name: 'Layout',
        type: 'struct',
        title: '通栏设置',
        groupName: '通栏设置',
    },
    Nav: {
        id: '260708',
        name: 'Nav',
        type: 'struct',
        title: '导航栏',
        groupName: '导航栏',
    },
    MainSwiper: {
        id: '287964',
        name: 'MainSwiper',
        type: 'recommend',
        title: '主轮播图',
        groupName: '主轮播图',
    },
    NewList1: {
        id: '287965',
        name: 'NewList1',
        type: 'recommend',
        title: '新闻列表1',
        groupName: '新闻',
    },
    NewList2: {
        id: '287966',
        name: 'NewList2',
        type: 'recommend',
        title: '新闻列表2',
        groupName: '新闻',
    },
    NewList3: {
        id: '287967',
        name: 'NewList3',
        type: 'recommend',
        title: '新闻列表3',
        groupName: '新闻',
    },
    ArticleList1: {
        id: '287968',
        name: 'ArticleList1',
        type: 'recommend',
        title: '文章列表1',
        groupName: '新闻',
    },
    ArticleList2: {
        id: '287969',
        name: 'ArticleList2',
        type: 'recommend',
        title: '文章列表2',
        groupName: '新闻',
    },
    SmallBanner1: {
        id: '260710',
        name: 'SmallBanner1',
        type: 'struct',
        title: '小banner1',
        groupName: '新闻',
    },
    SmallBanner2: {
        id: '260711',
        name: 'SmallBanner2',
        type: 'struct',
        title: '小banner2',
        groupName: '新闻',
    },
    Banner2: {
        id: '260712',
        name: 'Banner2',
        type: 'struct',
        title: '大banner2',
        groupName: 'part2',
    },
    GridBox: {
        id: '11-35126-',
        name: 'GridBox',
        type: 'dynamic',
        title: '栅格图片',
        groupName: 'part2',
    },
    Banner3: {
        id: '260713',
        name: 'Banner3',
        type: 'struct',
        title: '大banner3',
        groupName: 'part3',
    },
    ImageArticle: {
        id: '287970',
        name: 'ImageArticle',
        type: 'recommend',
        title: '图文列表',
        groupName: 'part3',
    },
    Banner4: {
        id: '260714',
        name: 'Banner4',
        type: 'struct',
        title: '大banner4',
        groupName: 'part4',
    },
    NewList4: {
        id: '11-35124-',
        name: 'NewList4',
        type: 'dynamic',
        title: '新闻列表4',
        groupName: 'part4',
    },
    Banner5: {
        id: '260716',
        name: 'Banner5',
        type: 'struct',
        title: '大banner5',
        groupName: 'part5',
    },
    Support: {
        id: '260717',
        name: 'Support',
        type: 'struct',
        title: '赞助企业',
        groupName: 'part5',
    }
};

module.exports = { ChipMap };
